/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ContributionResource } from '../models/ContributionResource';
import type { ContributionsPeopleRequest } from '../models/ContributionsPeopleRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class ContributionsPeopleService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Get people contributions
     * @returns any OK
     * @throws ApiError
     */
    public getContributionsPeople({
        requestBody,
    }: {
        /**
         * Contributions people payload
         */
        requestBody: ContributionsPeopleRequest,
    }): CancelablePromise<{
        data: Array<ContributionResource>;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/contributions/people',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `User is unauthorized.`,
                403: `Access Denied`,
            },
        });
    }

}
